// extracted by mini-css-extract-plugin
export default {"form":"styles_form__IKhPD","input":"styles_input__Kes2+"};